import { createContext } from 'react';
import { TEnterpriseTabSection } from '../../../../../../interfaces/enterprise-profile/enterprise.interface';

const EnterprofileTabContext = createContext<TEnterpriseTabSection | undefined>(
  undefined
);

export default EnterprofileTabContext;
